module.exports = __webpack_public_path__ + "static/media/icon_social-drive.cd374a65.svg";